import { whiteColor, shadowColor, lightBlue, lightgray } from 'theme/color';

export const vendorStatusContainer = {
  'box-shadow': '0px 1px 8px #00000026',

  'border-radius': '10px',
};
export const vendorStatusHeader = {
  display: 'flex',
  'justify-content': 'center',
  'align-items': 'center',
};

export const vendorCard = {
  background: whiteColor,
  boxShadow: 'none',
  // border: "1px solid rgba(17, 35, 71, 0.1)",
  border: ' 0.5px solid #E4E4E4',
  borderRadius: '5px',
  padding: '20px',
  marginBottom: '30px',
  marginTop: '30px',
};

export const counterOffer = {
  background: whiteColor,
  border: '0.5px solid #E4E4E4',
  borderRadius: '5px',
  alignItems: 'center',
  padding: '24px 18px',
  // boxShadow: "none",
  width: '100%',
  justifyContent: 'space-between',
};

export const counterOfferButton = {
  borderRadius: '54px',

  width: 'fit-content',
  padding: '6px 14px',
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
};

export const vendorAvatar = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  padding: '0 10px',
  // padding: "10px",
  borderRadius: '5px',
  height: '40px !important',
  border: '1px solid rgba(0, 0, 0, 0.12)',
};

export const vendorTop = {
  display: 'flex',
  // alignItems: "center",
  marginBottom: '20px',
};

export const vendorRight = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
  // marginRight:"-80px"
};

export const smsCall = {
  color: lightBlue,
  border: `1px solid ${lightgray}`,
  borderRadius: '10px',
  padding: '16px',
  fontSize: '62px',
};

export const alignCenter = {
  display: 'flex',
  width: '400px',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '15px',
};
